import { render, staticRenderFns } from "./writeComment.vue?vue&type=template&id=3834ab46&scoped=true&"
import script from "./writeComment.vue?vue&type=script&lang=js&"
export * from "./writeComment.vue?vue&type=script&lang=js&"
import style0 from "./writeComment.vue?vue&type=style&index=0&id=3834ab46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3834ab46",
  null
  
)

export default component.exports